var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userPermissions.indexOf("user_detail")>-1)?_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.jumpToDetail(_vm.userInfo)}}},[_vm._v(" "+_vm._s(_vm.userInfo.nickname || ' -- ')+" ")]):_c('span',[_vm._v(_vm._s(_vm.userInfo.nickname || ' -- '))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }